import React from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps
} from '@fortawesome/react-fontawesome';

import MDTypography, { MDTypographyProps } from '@components/MDTypography';

interface Props extends FontAwesomeIconProps {
  typographyProps?: Omit<MDTypographyProps, 'variant'>;
}

const FaIcon: React.FC<Props> = ({ typographyProps, ...rest }) => (
  <MDTypography {...typographyProps}>
    <FontAwesomeIcon {...rest} />
  </MDTypography>
);

export default FaIcon;
